'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _draftJs = require('draft-js');

var _ActionTypes = require('../constants/ActionTypes');

var _isEntityActive = require('../utils/isEntityActive');

var _isEntityActive2 = _interopRequireDefault(_isEntityActive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getBlockRenderMap = function getBlockRenderMap(customBlockMap) {
  var customBlockRenderMap = (0, _immutable.Map)(Object.keys(customBlockMap).reduce(function (map, blockName) {
    map[blockName] = {
      element: 'div'
    };
    return map;
  }, {
    // 'paragraph': {
    //   element: 'div',
    // },
    'unstyled': {
      element: 'div'
    },
    'atomic': {
      element: 'div'
    }
  }));
  var mergedRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(customBlockRenderMap);

  return mergedRenderMap;
};

var getActiveMap = function getActiveMap(_ref) {
  var editorState = _ref.editorState,
      blockNames = _ref.blockNames,
      styleNames = _ref.styleNames,
      decoratorNames = _ref.decoratorNames;

  var selectionState = editorState.getSelection();
  var currentBlockType = editorState.getCurrentContent().getBlockForKey(selectionState.getStartKey()).getType();
  var currentStyleNames = editorState.getCurrentInlineStyle();
  var blockActiveMap = blockNames.reduce(function (map, blockName) {
    map[blockName] = blockName === currentBlockType;
    return map;
  }, {});
  var styleActiveMap = styleNames.reduce(function (map, styleName) {
    map[styleName] = currentStyleNames.has(styleName);
    return map;
  }, {});
  var entityActiveMap = decoratorNames.reduce(function (map, decoratorName) {
    map[decoratorName] = (0, _isEntityActive2.default)(editorState, decoratorName);
    return map;
  }, {});

  return _extends({}, blockActiveMap, styleActiveMap, entityActiveMap);
};

var initialEditorState = {};
var editorReducer = function editorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialEditorState;
  var action = arguments[1];

  switch (action.type) {
    case _ActionTypes.INIT:
      {
        var config = action.config;
        var _config$customStyleMa = config.customStyleMap,
            customStyleMap = _config$customStyleMa === undefined ? {} : _config$customStyleMa,
            _config$customBlockMa = config.customBlockMap,
            customBlockMap = _config$customBlockMa === undefined ? {} : _config$customBlockMa,
            _config$entityMap = config.entityMap,
            entityMap = _config$entityMap === undefined ? {} : _config$entityMap,
            _config$decoratorMap = config.decoratorMap,
            decoratorMap = _config$decoratorMap === undefined ? {} : _config$decoratorMap,
            _config$renderMap = config.renderMap,
            renderMap = _config$renderMap === undefined ? {} : _config$renderMap;

        var defaultStyleNames = Object.keys(_draftJs.DefaultDraftInlineStyle);
        var styleNames = [].concat(_toConsumableArray(defaultStyleNames), _toConsumableArray(Object.keys(customStyleMap || [])));
        var defaultBlockNames = _draftJs.DefaultDraftBlockRenderMap.keySeq().toArray();

        var editorState = action.editorState || _draftJs.EditorState.createEmpty();
        var blockRenderMap = getBlockRenderMap(customBlockMap);
        var blockRendererFn = function blockRendererFn(contentBlock) {
          var name = contentBlock.getType();

          return customBlockMap[name];
        };
        var blockNames = blockRenderMap.keySeq().toArray();
        var entityNames = Object.keys(entityMap);
        var decoratorNames = Object.keys(decoratorMap);
        var decorators = decoratorNames.map(function (decoratorName) {
          return decoratorMap[decoratorName];
        });

        editorState = _draftJs.EditorState.set(editorState, {
          decorator: new _draftJs.CompositeDecorator(decorators)
        });
        return {
          // private redux-draft props
          _instance: null,
          _initialized: true,

          // public redux-draft props
          name: action.editorName,
          config: config,
          defaultStyleNames: defaultStyleNames,
          styleNames: styleNames,
          defaultBlockNames: defaultBlockNames,
          blockNames: blockNames,
          entityNames: entityNames,
          decoratorNames: decoratorNames,
          decorators: decorators,
          activeMap: getActiveMap({
            editorState: editorState,
            blockNames: blockNames,
            styleNames: styleNames,
            decoratorNames: decoratorNames
          }),
          renderMap: renderMap,

          // draft props
          editorState: editorState,
          customStyleMap: customStyleMap,
          blockRenderMap: blockRenderMap,
          blockRendererFn: blockRendererFn,
          readOnly: false
        };
      }

    case _ActionTypes.SET_REF:
      {
        return _extends({}, state, {
          _instance: action.editorInstance
        });
      }

    case _ActionTypes.UPDATE_EDITOR_STATE:
      {
        var _blockNames = state.blockNames,
            _styleNames = state.styleNames,
            _decoratorNames = state.decoratorNames;
        var _editorState = action.editorState;


        return _extends({}, state, {
          editorState: _editorState,
          activeMap: getActiveMap({
            editorState: _editorState,
            blockNames: _blockNames,
            styleNames: _styleNames,
            decoratorNames: _decoratorNames
          })
        });
      }

    case _ActionTypes.UPDATE_EDITOR_STATE_FROM_RAW:
      {
        var _blockNames2 = state.blockNames,
            _styleNames2 = state.styleNames,
            _decoratorNames2 = state.decoratorNames,
            _decorators = state.decorators;
        var rawContent = action.rawContent;

        var contentState = (0, _draftJs.convertFromRaw)(rawContent);
        var _editorState2 = _draftJs.EditorState.createWithContent(contentState, new _draftJs.CompositeDecorator(_decorators));

        return _extends({}, state, {
          editorState: _editorState2,
          activeMap: getActiveMap({
            editorState: _editorState2,
            blockNames: _blockNames2,
            styleNames: _styleNames2,
            decoratorNames: _decoratorNames2
          })
        });
      }

    case _ActionTypes.UPDATE_READ_ONLY:
      {
        return _extends({}, state, {
          readOnly: action.readOnly
        });
      }

    case _ActionTypes.TOGGLE_BLOCK:
      {
        var _blockNames3 = state.blockNames,
            _styleNames3 = state.styleNames,
            _decoratorNames3 = state.decoratorNames;

        var _editorState3 = _draftJs.RichUtils.toggleBlockType(state.editorState, action.blockName);

        return _extends({}, state, {
          editorState: _editorState3,
          activeMap: getActiveMap({
            editorState: _editorState3,
            blockNames: _blockNames3,
            styleNames: _styleNames3,
            decoratorNames: _decoratorNames3
          })
        });
      }

    case _ActionTypes.TOGGLE_STYLE:
      {
        var _blockNames4 = state.blockNames,
            _styleNames4 = state.styleNames,
            _decoratorNames4 = state.decoratorNames;

        var _editorState4 = _draftJs.RichUtils.toggleInlineStyle(state.editorState, action.styleName);

        return _extends({}, state, {
          editorState: _editorState4,
          activeMap: getActiveMap({
            editorState: _editorState4,
            blockNames: _blockNames4,
            styleNames: _styleNames4,
            decoratorNames: _decoratorNames4
          })
        });
      }

    case _ActionTypes.APPLY_BLOCK:
      {
        var _editorState5 = state.editorState,
            _blockNames5 = state.blockNames,
            _styleNames5 = state.styleNames,
            _decoratorNames5 = state.decoratorNames;

        var _contentState = _editorState5.getCurrentContent();
        var selectionState = _editorState5.getSelection();
        var setBlock = _draftJs.Modifier.setBlockType(_contentState, selectionState, action.blockName);

        _contentState = _draftJs.EditorState.push(_editorState5, setBlock, 'change-block-type');
        _editorState5 = _draftJs.EditorState.forceSelection(_contentState, setBlock.getSelectionAfter());
        return _extends({}, state, {
          editorState: _editorState5,
          activeMap: getActiveMap({
            editorState: _editorState5,
            blockNames: _blockNames5,
            styleNames: _styleNames5,
            decoratorNames: _decoratorNames5
          })
        });
      }

    case _ActionTypes.REMOVE_ENTITY:
      {
        var _editorState6 = state.editorState,
            _blockNames6 = state.blockNames,
            _styleNames6 = state.styleNames,
            _decoratorNames6 = state.decoratorNames;

        var _selectionState = _editorState6.getSelection();
        var _contentState2 = _editorState6.getCurrentContent();
        var contentStateWithoutEntity = _draftJs.Modifier.applyEntity(_contentState2, _selectionState, null);
        _editorState6 = _draftJs.EditorState.push(_editorState6, contentStateWithoutEntity, 'apply-entity');

        return _extends({}, state, {
          editorState: _editorState6,
          activeMap: getActiveMap({
            editorState: _editorState6,
            blockNames: _blockNames6,
            styleNames: _styleNames6,
            decoratorNames: _decoratorNames6
          })
        });
      }

    case _ActionTypes.APPLY_ENTITY:
      {
        var _editorState7 = state.editorState,
            _blockNames7 = state.blockNames,
            _styleNames7 = state.styleNames,
            _decoratorNames7 = state.decoratorNames;

        var _selectionState2 = _editorState7.getSelection();
        var _contentState3 = _editorState7.getCurrentContent();

        var contentStateWithNewEntity = _contentState3.createEntity(action.entityName, action.mutability, action.data);
        var entityKey = contentStateWithNewEntity.getLastCreatedEntityKey();
        var contentStateWithEntity = _draftJs.Modifier.applyEntity(contentStateWithNewEntity, _selectionState2, entityKey);
        _editorState7 = _draftJs.EditorState.push(_editorState7, contentStateWithEntity, 'apply-entity');

        return _extends({}, state, {
          editorState: _editorState7,
          activeMap: getActiveMap({
            editorState: _editorState7,
            blockNames: _blockNames7,
            styleNames: _styleNames7,
            decoratorNames: _decoratorNames7
          })
        });
      }

    case _ActionTypes.INSERT_ENTITY:
      {
        var _editorState8 = state.editorState,
            _blockNames8 = state.blockNames,
            _styleNames8 = state.styleNames,
            _decoratorNames8 = state.decoratorNames;

        var _selectionState3 = _editorState8.getSelection();
        var _contentState4 = _editorState8.getCurrentContent();

        var _contentStateWithNewEntity = _contentState4.createEntity(action.entityName, action.mutability, action.data);
        var _entityKey = _contentStateWithNewEntity.getLastCreatedEntityKey();

        var firstBlank = _draftJs.Modifier.insertText(_contentState4, _selectionState3, ' ', null, null);
        var withEntity = _draftJs.Modifier.insertText(firstBlank, _selectionState3, action.text, null, _entityKey);
        var withBlank = _draftJs.Modifier.insertText(withEntity, _selectionState3, ' ', null, null);

        _editorState8 = _draftJs.EditorState.push(_editorState8, withBlank, 'insert-text');

        return _extends({}, state, {
          editorState: _editorState8,
          activeMap: getActiveMap({
            editorState: _editorState8,
            blockNames: _blockNames8,
            styleNames: _styleNames8,
            decoratorNames: _decoratorNames8
          })
        });
      }

    case _ActionTypes.INSERT_ATOMIC_BLOCK:
      {
        var _editorState9 = state.editorState,
            _blockNames9 = state.blockNames,
            _styleNames9 = state.styleNames,
            _decoratorNames9 = state.decoratorNames;

        var _contentState5 = _editorState9.getCurrentContent();
        var _contentStateWithNewEntity2 = _contentState5.createEntity(action.entityName, action.mutability, action.data);
        var _entityKey2 = _contentStateWithNewEntity2.getLastCreatedEntityKey();

        _editorState9 = _draftJs.EditorState.set(_editorState9, { currentContent: _contentStateWithNewEntity2 });
        _editorState9 = _draftJs.AtomicBlockUtils.insertAtomicBlock(_editorState9, _entityKey2, action.text);
        return _extends({}, state, {
          editorState: _editorState9,
          activeMap: getActiveMap({
            editorState: _editorState9,
            blockNames: _blockNames9,
            styleNames: _styleNames9,
            decoratorNames: _decoratorNames9
          })
        });
      }

    case _ActionTypes.REMOVE_BLOCK:
      {
        var _editorState10 = state.editorState;

        var _contentState6 = _editorState10.getCurrentContent();
        var block = _contentState6.getBlockForKey(action.blockKey);
        var targetRange = new _draftJs.SelectionState({
          anchorKey: action.blockKey,
          anchorOffset: 0,
          focusKey: action.blockKey,
          focusOffset: block.getLength()
        });
        var withoutBlock = _draftJs.Modifier.removeRange(_contentState6, targetRange, 'backward');
        var resetBlock = _draftJs.Modifier.setBlockType(withoutBlock, withoutBlock.getSelectionAfter(), 'unstyled');

        _contentState6 = _draftJs.EditorState.push(_editorState10, resetBlock, 'remove-range');
        _editorState10 = _draftJs.EditorState.forceSelection(_contentState6, resetBlock.getSelectionAfter());
        return _extends({}, state, {
          editorState: _editorState10
        });
      }

    case _ActionTypes.UPDATE_ENTITY_DATA:
      {
        var _editorState11 = state.editorState,
            _decorators2 = state.decorators;

        var _contentState7 = _editorState11.getCurrentContent();
        _contentState7 = _contentState7.mergeEntityData(action.entityKey, action.data);
        _editorState11 = _draftJs.EditorState.createWithContent(_contentState7, new _draftJs.CompositeDecorator(_decorators2));

        return _extends({}, state, {
          editorState: _editorState11
        });
      }
  }
};

var initialState = {};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var editorName = action.editorName;


  if (editorName) {
    return _extends({}, state, _defineProperty({}, editorName, editorReducer(state[editorName], action)));
  } else {
    return state;
  }
};
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlZHVjZXJzL2luZGV4LmpzIl0sIm5hbWVzIjpbImdldEJsb2NrUmVuZGVyTWFwIiwiY3VzdG9tQmxvY2tNYXAiLCJjdXN0b21CbG9ja1JlbmRlck1hcCIsIk9iamVjdCIsImtleXMiLCJyZWR1Y2UiLCJtYXAiLCJibG9ja05hbWUiLCJlbGVtZW50IiwibWVyZ2VkUmVuZGVyTWFwIiwibWVyZ2UiLCJnZXRBY3RpdmVNYXAiLCJlZGl0b3JTdGF0ZSIsImJsb2NrTmFtZXMiLCJzdHlsZU5hbWVzIiwiZGVjb3JhdG9yTmFtZXMiLCJzZWxlY3Rpb25TdGF0ZSIsImdldFNlbGVjdGlvbiIsImN1cnJlbnRCbG9ja1R5cGUiLCJnZXRDdXJyZW50Q29udGVudCIsImdldEJsb2NrRm9yS2V5IiwiZ2V0U3RhcnRLZXkiLCJnZXRUeXBlIiwiY3VycmVudFN0eWxlTmFtZXMiLCJnZXRDdXJyZW50SW5saW5lU3R5bGUiLCJibG9ja0FjdGl2ZU1hcCIsInN0eWxlQWN0aXZlTWFwIiwic3R5bGVOYW1lIiwiaGFzIiwiZW50aXR5QWN0aXZlTWFwIiwiZGVjb3JhdG9yTmFtZSIsImluaXRpYWxFZGl0b3JTdGF0ZSIsImVkaXRvclJlZHVjZXIiLCJzdGF0ZSIsImFjdGlvbiIsInR5cGUiLCJjb25maWciLCJjdXN0b21TdHlsZU1hcCIsImVudGl0eU1hcCIsImRlY29yYXRvck1hcCIsInJlbmRlck1hcCIsImRlZmF1bHRTdHlsZU5hbWVzIiwiZGVmYXVsdEJsb2NrTmFtZXMiLCJrZXlTZXEiLCJ0b0FycmF5IiwiY3JlYXRlRW1wdHkiLCJibG9ja1JlbmRlck1hcCIsImJsb2NrUmVuZGVyZXJGbiIsImNvbnRlbnRCbG9jayIsIm5hbWUiLCJlbnRpdHlOYW1lcyIsImRlY29yYXRvcnMiLCJzZXQiLCJkZWNvcmF0b3IiLCJfaW5zdGFuY2UiLCJfaW5pdGlhbGl6ZWQiLCJlZGl0b3JOYW1lIiwiYWN0aXZlTWFwIiwicmVhZE9ubHkiLCJlZGl0b3JJbnN0YW5jZSIsInJhd0NvbnRlbnQiLCJjb250ZW50U3RhdGUiLCJjcmVhdGVXaXRoQ29udGVudCIsInRvZ2dsZUJsb2NrVHlwZSIsInRvZ2dsZUlubGluZVN0eWxlIiwic2V0QmxvY2siLCJzZXRCbG9ja1R5cGUiLCJwdXNoIiwiZm9yY2VTZWxlY3Rpb24iLCJnZXRTZWxlY3Rpb25BZnRlciIsImNvbnRlbnRTdGF0ZVdpdGhvdXRFbnRpdHkiLCJhcHBseUVudGl0eSIsImNvbnRlbnRTdGF0ZVdpdGhOZXdFbnRpdHkiLCJjcmVhdGVFbnRpdHkiLCJlbnRpdHlOYW1lIiwibXV0YWJpbGl0eSIsImRhdGEiLCJlbnRpdHlLZXkiLCJnZXRMYXN0Q3JlYXRlZEVudGl0eUtleSIsImNvbnRlbnRTdGF0ZVdpdGhFbnRpdHkiLCJmaXJzdEJsYW5rIiwiaW5zZXJ0VGV4dCIsIndpdGhFbnRpdHkiLCJ0ZXh0Iiwid2l0aEJsYW5rIiwiY3VycmVudENvbnRlbnQiLCJpbnNlcnRBdG9taWNCbG9jayIsImJsb2NrIiwiYmxvY2tLZXkiLCJ0YXJnZXRSYW5nZSIsImFuY2hvcktleSIsImFuY2hvck9mZnNldCIsImZvY3VzS2V5IiwiZm9jdXNPZmZzZXQiLCJnZXRMZW5ndGgiLCJ3aXRob3V0QmxvY2siLCJyZW1vdmVSYW5nZSIsInJlc2V0QmxvY2siLCJtZXJnZUVudGl0eURhdGEiLCJpbml0aWFsU3RhdGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBV0E7O0FBZ0JBOzs7Ozs7Ozs7O0FBRUEsSUFBSUEsb0JBQW9CLFNBQXBCQSxpQkFBb0IsQ0FBQ0MsY0FBRCxFQUFvQjtBQUMxQyxNQUFJQyx1QkFBdUIsb0JBQUlDLE9BQzVCQyxJQUQ0QixDQUN2QkgsY0FEdUIsRUFFNUJJLE1BRjRCLENBRXJCLFVBQUNDLEdBQUQsRUFBTUMsU0FBTixFQUFvQjtBQUMxQkQsUUFBSUMsU0FBSixJQUFpQjtBQUNmQyxlQUFTO0FBRE0sS0FBakI7QUFHQSxXQUFPRixHQUFQO0FBQ0QsR0FQNEIsRUFPMUI7QUFDRDtBQUNBO0FBQ0E7QUFDQSxnQkFBWTtBQUNWRSxlQUFTO0FBREMsS0FKWDtBQU9ELGNBQVU7QUFDUkEsZUFBUztBQUREO0FBUFQsR0FQMEIsQ0FBSixDQUEzQjtBQWtCQSxNQUFJQyxrQkFBa0Isb0NBQ25CQyxLQURtQixDQUNiUixvQkFEYSxDQUF0Qjs7QUFHQSxTQUFPTyxlQUFQO0FBQ0QsQ0F2QkQ7O0FBeUJBLElBQUlFLGVBQWUsU0FBZkEsWUFBZSxPQUViO0FBQUEsTUFESkMsV0FDSSxRQURKQSxXQUNJO0FBQUEsTUFEU0MsVUFDVCxRQURTQSxVQUNUO0FBQUEsTUFEcUJDLFVBQ3JCLFFBRHFCQSxVQUNyQjtBQUFBLE1BRGlDQyxjQUNqQyxRQURpQ0EsY0FDakM7O0FBQ0osTUFBSUMsaUJBQWlCSixZQUFZSyxZQUFaLEVBQXJCO0FBQ0EsTUFBSUMsbUJBQW1CTixZQUNwQk8saUJBRG9CLEdBRXBCQyxjQUZvQixDQUVMSixlQUFlSyxXQUFmLEVBRkssRUFHcEJDLE9BSG9CLEVBQXZCO0FBSUEsTUFBSUMsb0JBQW9CWCxZQUFZWSxxQkFBWixFQUF4QjtBQUNBLE1BQUlDLGlCQUFpQlosV0FDbEJSLE1BRGtCLENBQ1gsVUFBQ0MsR0FBRCxFQUFNQyxTQUFOLEVBQW9CO0FBQzFCRCxRQUFJQyxTQUFKLElBQ0VBLGNBQWNXLGdCQURoQjtBQUdBLFdBQU9aLEdBQVA7QUFDRCxHQU5rQixFQU1oQixFQU5nQixDQUFyQjtBQU9BLE1BQUlvQixpQkFBaUJaLFdBQ2xCVCxNQURrQixDQUNYLFVBQUNDLEdBQUQsRUFBTXFCLFNBQU4sRUFBb0I7QUFDMUJyQixRQUFJcUIsU0FBSixJQUFpQkosa0JBQWtCSyxHQUFsQixDQUFzQkQsU0FBdEIsQ0FBakI7QUFDQSxXQUFPckIsR0FBUDtBQUNELEdBSmtCLEVBSWhCLEVBSmdCLENBQXJCO0FBS0EsTUFBSXVCLGtCQUFrQmQsZUFDbkJWLE1BRG1CLENBQ1osVUFBQ0MsR0FBRCxFQUFNd0IsYUFBTixFQUF3QjtBQUM5QnhCLFFBQUl3QixhQUFKLElBQXFCLDhCQUFlbEIsV0FBZixFQUE0QmtCLGFBQTVCLENBQXJCO0FBQ0EsV0FBT3hCLEdBQVA7QUFDRCxHQUptQixFQUlqQixFQUppQixDQUF0Qjs7QUFNQSxzQkFDS21CLGNBREwsRUFFS0MsY0FGTCxFQUdLRyxlQUhMO0FBS0QsQ0FoQ0Q7O0FBa0NBLElBQUlFLHFCQUFxQixFQUF6QjtBQUNBLElBQUlDLGdCQUFnQixTQUFoQkEsYUFBZ0IsR0FBd0M7QUFBQSxNQUF2Q0MsS0FBdUMsdUVBQS9CRixrQkFBK0I7QUFBQSxNQUFYRyxNQUFXOztBQUMxRCxVQUFRQSxPQUFPQyxJQUFmO0FBQ0U7QUFBVztBQUFBLFlBQ0hDLE1BREcsR0FDUUYsTUFEUixDQUNIRSxNQURHO0FBQUEsb0NBUUxBLE1BUkssQ0FHUEMsY0FITztBQUFBLFlBR1BBLGNBSE8seUNBR1UsRUFIVjtBQUFBLG9DQVFMRCxNQVJLLENBSVBuQyxjQUpPO0FBQUEsWUFJUEEsY0FKTyx5Q0FJVSxFQUpWO0FBQUEsZ0NBUUxtQyxNQVJLLENBS1BFLFNBTE87QUFBQSxZQUtQQSxTQUxPLHFDQUtLLEVBTEw7QUFBQSxtQ0FRTEYsTUFSSyxDQU1QRyxZQU5PO0FBQUEsWUFNUEEsWUFOTyx3Q0FNUSxFQU5SO0FBQUEsZ0NBUUxILE1BUkssQ0FPUEksU0FQTztBQUFBLFlBT1BBLFNBUE8scUNBT0ssRUFQTDs7QUFTVCxZQUFJQyxvQkFBb0J0QyxPQUFPQyxJQUFQLGtDQUF4QjtBQUNBLFlBQUlVLDBDQUNDMkIsaUJBREQsc0JBRUN0QyxPQUFPQyxJQUFQLENBQVlpQyxrQkFBa0IsRUFBOUIsQ0FGRCxFQUFKO0FBSUEsWUFBSUssb0JBQ0Ysb0NBQTJCQyxNQUEzQixHQUFvQ0MsT0FBcEMsRUFERjs7QUFJQSxZQUFJaEMsY0FDRnNCLE9BQU90QixXQUFQLElBQ0EscUJBQVlpQyxXQUFaLEVBRkY7QUFJQSxZQUFJQyxpQkFBaUI5QyxrQkFBa0JDLGNBQWxCLENBQXJCO0FBQ0EsWUFBSThDLGtCQUFrQixTQUFsQkEsZUFBa0IsQ0FBQ0MsWUFBRCxFQUFrQjtBQUN0QyxjQUFJQyxPQUFPRCxhQUFhMUIsT0FBYixFQUFYOztBQUVBLGlCQUFPckIsZUFBZWdELElBQWYsQ0FBUDtBQUNELFNBSkQ7QUFLQSxZQUFJcEMsYUFDRmlDLGVBQWVILE1BQWYsR0FBd0JDLE9BQXhCLEVBREY7QUFHQSxZQUFJTSxjQUFjL0MsT0FBT0MsSUFBUCxDQUFZa0MsU0FBWixDQUFsQjtBQUNBLFlBQUl2QixpQkFBaUJaLE9BQU9DLElBQVAsQ0FBWW1DLFlBQVosQ0FBckI7QUFDQSxZQUFJWSxhQUNGcEMsZUFBZVQsR0FBZixDQUFtQjtBQUFBLGlCQUFpQmlDLGFBQWFULGFBQWIsQ0FBakI7QUFBQSxTQUFuQixDQURGOztBQUlBbEIsc0JBQWMscUJBQVl3QyxHQUFaLENBQWdCeEMsV0FBaEIsRUFBNkI7QUFDekN5QyxxQkFBVyxnQ0FBdUJGLFVBQXZCO0FBRDhCLFNBQTdCLENBQWQ7QUFHQSxlQUFPO0FBQ0w7QUFDQUcscUJBQVcsSUFGTjtBQUdMQyx3QkFBYyxJQUhUOztBQUtMO0FBQ0FOLGdCQUFNZixPQUFPc0IsVUFOUjtBQU9McEIsd0JBUEs7QUFRTEssOENBUks7QUFTTDNCLGdDQVRLO0FBVUw0Qiw4Q0FWSztBQVdMN0IsZ0NBWEs7QUFZTHFDLGtDQVpLO0FBYUxuQyx3Q0FiSztBQWNMb0MsZ0NBZEs7QUFlTE0scUJBQVc5QyxhQUFhO0FBQ3RCQyxvQ0FEc0I7QUFFdEJDLGtDQUZzQjtBQUd0QkMsa0NBSHNCO0FBSXRCQztBQUpzQixXQUFiLENBZk47QUFxQkx5Qiw4QkFyQks7O0FBdUJMO0FBQ0E1QixrQ0F4Qks7QUF5Qkx5Qix3Q0F6Qks7QUEwQkxTLHdDQTFCSztBQTJCTEMsMENBM0JLO0FBNEJMVyxvQkFBVTtBQTVCTCxTQUFQO0FBOEJEOztBQUVEO0FBQWM7QUFDWiw0QkFDS3pCLEtBREw7QUFFRXFCLHFCQUFXcEIsT0FBT3lCO0FBRnBCO0FBSUQ7O0FBRUQ7QUFBMEI7QUFBQSxZQUV0QjlDLFdBRnNCLEdBS3BCb0IsS0FMb0IsQ0FFdEJwQixVQUZzQjtBQUFBLFlBR3RCQyxXQUhzQixHQUtwQm1CLEtBTG9CLENBR3RCbkIsVUFIc0I7QUFBQSxZQUl0QkMsZUFKc0IsR0FLcEJrQixLQUxvQixDQUl0QmxCLGNBSnNCO0FBQUEsWUFNbEJILFlBTmtCLEdBTUZzQixNQU5FLENBTWxCdEIsV0FOa0I7OztBQVF4Qiw0QkFDS3FCLEtBREw7QUFFRXJCLG1DQUZGO0FBR0U2QyxxQkFBVzlDLGFBQWE7QUFDdEJDLHFDQURzQjtBQUV0QkMsbUNBRnNCO0FBR3RCQyxtQ0FIc0I7QUFJdEJDO0FBSnNCLFdBQWI7QUFIYjtBQVVEOztBQUVEO0FBQW1DO0FBQUEsWUFFL0JGLFlBRitCLEdBTTdCb0IsS0FONkIsQ0FFL0JwQixVQUYrQjtBQUFBLFlBRy9CQyxZQUgrQixHQU03Qm1CLEtBTjZCLENBRy9CbkIsVUFIK0I7QUFBQSxZQUkvQkMsZ0JBSitCLEdBTTdCa0IsS0FONkIsQ0FJL0JsQixjQUorQjtBQUFBLFlBSy9Cb0MsV0FMK0IsR0FNN0JsQixLQU42QixDQUsvQmtCLFVBTCtCO0FBQUEsWUFPM0JTLFVBUDJCLEdBT1oxQixNQVBZLENBTzNCMEIsVUFQMkI7O0FBUWpDLFlBQUlDLGVBQWUsNkJBQWVELFVBQWYsQ0FBbkI7QUFDQSxZQUFJaEQsZ0JBQWMscUJBQVlrRCxpQkFBWixDQUNoQkQsWUFEZ0IsRUFFaEIsZ0NBQXVCVixXQUF2QixDQUZnQixDQUFsQjs7QUFLQSw0QkFDS2xCLEtBREw7QUFFRXJCLG9DQUZGO0FBR0U2QyxxQkFBVzlDLGFBQWE7QUFDdEJDLHNDQURzQjtBQUV0QkMsb0NBRnNCO0FBR3RCQyxvQ0FIc0I7QUFJdEJDO0FBSnNCLFdBQWI7QUFIYjtBQVVEOztBQUVEO0FBQXVCO0FBQ3JCLDRCQUNLa0IsS0FETDtBQUVFeUIsb0JBQVV4QixPQUFPd0I7QUFGbkI7QUFJRDs7QUFFRDtBQUFtQjtBQUFBLFlBRWY3QyxZQUZlLEdBS2JvQixLQUxhLENBRWZwQixVQUZlO0FBQUEsWUFHZkMsWUFIZSxHQUtibUIsS0FMYSxDQUdmbkIsVUFIZTtBQUFBLFlBSWZDLGdCQUplLEdBS2JrQixLQUxhLENBSWZsQixjQUplOztBQU1qQixZQUFJSCxnQkFBYyxtQkFBVW1ELGVBQVYsQ0FDaEI5QixNQUFNckIsV0FEVSxFQUVoQnNCLE9BQU8zQixTQUZTLENBQWxCOztBQUtBLDRCQUNLMEIsS0FETDtBQUVFckIsb0NBRkY7QUFHRTZDLHFCQUFXOUMsYUFBYTtBQUN0QkMsc0NBRHNCO0FBRXRCQyxvQ0FGc0I7QUFHdEJDLG9DQUhzQjtBQUl0QkM7QUFKc0IsV0FBYjtBQUhiO0FBVUQ7O0FBRUQ7QUFBbUI7QUFBQSxZQUVmRixZQUZlLEdBS2JvQixLQUxhLENBRWZwQixVQUZlO0FBQUEsWUFHZkMsWUFIZSxHQUtibUIsS0FMYSxDQUdmbkIsVUFIZTtBQUFBLFlBSWZDLGdCQUplLEdBS2JrQixLQUxhLENBSWZsQixjQUplOztBQU1qQixZQUFJSCxnQkFBYyxtQkFBVW9ELGlCQUFWLENBQ2hCL0IsTUFBTXJCLFdBRFUsRUFFaEJzQixPQUFPUCxTQUZTLENBQWxCOztBQUtBLDRCQUNLTSxLQURMO0FBRUVyQixvQ0FGRjtBQUdFNkMscUJBQVc5QyxhQUFhO0FBQ3RCQyxzQ0FEc0I7QUFFdEJDLG9DQUZzQjtBQUd0QkMsb0NBSHNCO0FBSXRCQztBQUpzQixXQUFiO0FBSGI7QUFVRDs7QUFFRDtBQUFrQjtBQUFBLFlBRWRILGFBRmMsR0FNWnFCLEtBTlksQ0FFZHJCLFdBRmM7QUFBQSxZQUdkQyxZQUhjLEdBTVpvQixLQU5ZLENBR2RwQixVQUhjO0FBQUEsWUFJZEMsWUFKYyxHQU1abUIsS0FOWSxDQUlkbkIsVUFKYztBQUFBLFlBS2RDLGdCQUxjLEdBTVprQixLQU5ZLENBS2RsQixjQUxjOztBQU9oQixZQUFJOEMsZ0JBQWVqRCxjQUFZTyxpQkFBWixFQUFuQjtBQUNBLFlBQUlILGlCQUFpQkosY0FBWUssWUFBWixFQUFyQjtBQUNBLFlBQUlnRCxXQUFXLGtCQUFTQyxZQUFULENBQ2JMLGFBRGEsRUFFYjdDLGNBRmEsRUFHYmtCLE9BQU8zQixTQUhNLENBQWY7O0FBTUFzRCx3QkFBZSxxQkFBWU0sSUFBWixDQUNidkQsYUFEYSxFQUVicUQsUUFGYSxFQUdiLG1CQUhhLENBQWY7QUFLQXJELHdCQUFjLHFCQUFZd0QsY0FBWixDQUNaUCxhQURZLEVBQ0VJLFNBQVNJLGlCQUFULEVBREYsQ0FBZDtBQUdBLDRCQUNLcEMsS0FETDtBQUVFckIsb0NBRkY7QUFHRTZDLHFCQUFXOUMsYUFBYTtBQUN0QkMsc0NBRHNCO0FBRXRCQyxvQ0FGc0I7QUFHdEJDLG9DQUhzQjtBQUl0QkM7QUFKc0IsV0FBYjtBQUhiO0FBVUQ7O0FBRUQ7QUFBb0I7QUFBQSxZQUVoQkgsYUFGZ0IsR0FNZHFCLEtBTmMsQ0FFaEJyQixXQUZnQjtBQUFBLFlBR2hCQyxZQUhnQixHQU1kb0IsS0FOYyxDQUdoQnBCLFVBSGdCO0FBQUEsWUFJaEJDLFlBSmdCLEdBTWRtQixLQU5jLENBSWhCbkIsVUFKZ0I7QUFBQSxZQUtoQkMsZ0JBTGdCLEdBTWRrQixLQU5jLENBS2hCbEIsY0FMZ0I7O0FBT2xCLFlBQUlDLGtCQUFpQkosY0FBWUssWUFBWixFQUFyQjtBQUNBLFlBQUk0QyxpQkFBZWpELGNBQVlPLGlCQUFaLEVBQW5CO0FBQ0EsWUFBSW1ELDRCQUE0QixrQkFBU0MsV0FBVCxDQUM5QlYsY0FEOEIsRUFFOUI3QyxlQUY4QixFQUc5QixJQUg4QixDQUFoQztBQUtBSix3QkFBYyxxQkFBWXVELElBQVosQ0FDWnZELGFBRFksRUFFWjBELHlCQUZZLEVBR1osY0FIWSxDQUFkOztBQU1BLDRCQUNLckMsS0FETDtBQUVFckIsb0NBRkY7QUFHRTZDLHFCQUFXOUMsYUFBYTtBQUN0QkMsc0NBRHNCO0FBRXRCQyxvQ0FGc0I7QUFHdEJDLG9DQUhzQjtBQUl0QkM7QUFKc0IsV0FBYjtBQUhiO0FBVUQ7O0FBRUQ7QUFBbUI7QUFBQSxZQUVmSCxhQUZlLEdBTWJxQixLQU5hLENBRWZyQixXQUZlO0FBQUEsWUFHZkMsWUFIZSxHQU1ib0IsS0FOYSxDQUdmcEIsVUFIZTtBQUFBLFlBSWZDLFlBSmUsR0FNYm1CLEtBTmEsQ0FJZm5CLFVBSmU7QUFBQSxZQUtmQyxnQkFMZSxHQU1ia0IsS0FOYSxDQUtmbEIsY0FMZTs7QUFPakIsWUFBSUMsbUJBQWlCSixjQUFZSyxZQUFaLEVBQXJCO0FBQ0EsWUFBSTRDLGlCQUFlakQsY0FBWU8saUJBQVosRUFBbkI7O0FBRUEsWUFBSXFELDRCQUE0QlgsZUFBYVksWUFBYixDQUM5QnZDLE9BQU93QyxVQUR1QixFQUU5QnhDLE9BQU95QyxVQUZ1QixFQUc5QnpDLE9BQU8wQyxJQUh1QixDQUFoQztBQUtBLFlBQUlDLFlBQVlMLDBCQUEwQk0sdUJBQTFCLEVBQWhCO0FBQ0EsWUFBSUMseUJBQXlCLGtCQUFTUixXQUFULENBQzNCQyx5QkFEMkIsRUFFM0J4RCxnQkFGMkIsRUFHM0I2RCxTQUgyQixDQUE3QjtBQUtBakUsd0JBQWMscUJBQVl1RCxJQUFaLENBQ1p2RCxhQURZLEVBRVptRSxzQkFGWSxFQUdaLGNBSFksQ0FBZDs7QUFNQSw0QkFDSzlDLEtBREw7QUFFRXJCLG9DQUZGO0FBR0U2QyxxQkFBVzlDLGFBQWE7QUFDdEJDLHNDQURzQjtBQUV0QkMsb0NBRnNCO0FBR3RCQyxvQ0FIc0I7QUFJdEJDO0FBSnNCLFdBQWI7QUFIYjtBQVVEOztBQUVEO0FBQW9CO0FBQUEsWUFFaEJILGFBRmdCLEdBTWRxQixLQU5jLENBRWhCckIsV0FGZ0I7QUFBQSxZQUdoQkMsWUFIZ0IsR0FNZG9CLEtBTmMsQ0FHaEJwQixVQUhnQjtBQUFBLFlBSWhCQyxZQUpnQixHQU1kbUIsS0FOYyxDQUloQm5CLFVBSmdCO0FBQUEsWUFLaEJDLGdCQUxnQixHQU1ka0IsS0FOYyxDQUtoQmxCLGNBTGdCOztBQU9sQixZQUFJQyxtQkFBaUJKLGNBQVlLLFlBQVosRUFBckI7QUFDQSxZQUFJNEMsaUJBQWVqRCxjQUFZTyxpQkFBWixFQUFuQjs7QUFFQSxZQUFJcUQsNkJBQTRCWCxlQUFhWSxZQUFiLENBQzlCdkMsT0FBT3dDLFVBRHVCLEVBRTlCeEMsT0FBT3lDLFVBRnVCLEVBRzlCekMsT0FBTzBDLElBSHVCLENBQWhDO0FBS0EsWUFBSUMsYUFBWUwsMkJBQTBCTSx1QkFBMUIsRUFBaEI7O0FBRUEsWUFBSUUsYUFBYSxrQkFBU0MsVUFBVCxDQUNmcEIsY0FEZSxFQUVmN0MsZ0JBRmUsRUFHZixHQUhlLEVBSWYsSUFKZSxFQUtmLElBTGUsQ0FBakI7QUFPQSxZQUFJa0UsYUFBYSxrQkFBU0QsVUFBVCxDQUNmRCxVQURlLEVBRWZoRSxnQkFGZSxFQUdma0IsT0FBT2lELElBSFEsRUFJZixJQUplLEVBS2ZOLFVBTGUsQ0FBakI7QUFPQSxZQUFJTyxZQUFZLGtCQUFTSCxVQUFULENBQ2RDLFVBRGMsRUFFZGxFLGdCQUZjLEVBR2QsR0FIYyxFQUlkLElBSmMsRUFLZCxJQUxjLENBQWhCOztBQVFBSix3QkFBYyxxQkFBWXVELElBQVosQ0FDWnZELGFBRFksRUFFWndFLFNBRlksRUFHWixhQUhZLENBQWQ7O0FBTUEsNEJBQ0tuRCxLQURMO0FBRUVyQixvQ0FGRjtBQUdFNkMscUJBQVc5QyxhQUFhO0FBQ3RCQyxzQ0FEc0I7QUFFdEJDLG9DQUZzQjtBQUd0QkMsb0NBSHNCO0FBSXRCQztBQUpzQixXQUFiO0FBSGI7QUFVRDs7QUFFRDtBQUEwQjtBQUFBLFlBRXRCSCxhQUZzQixHQU1wQnFCLEtBTm9CLENBRXRCckIsV0FGc0I7QUFBQSxZQUd0QkMsWUFIc0IsR0FNcEJvQixLQU5vQixDQUd0QnBCLFVBSHNCO0FBQUEsWUFJdEJDLFlBSnNCLEdBTXBCbUIsS0FOb0IsQ0FJdEJuQixVQUpzQjtBQUFBLFlBS3RCQyxnQkFMc0IsR0FNcEJrQixLQU5vQixDQUt0QmxCLGNBTHNCOztBQU94QixZQUFJOEMsaUJBQWVqRCxjQUFZTyxpQkFBWixFQUFuQjtBQUNBLFlBQUlxRCw4QkFBNEJYLGVBQWFZLFlBQWIsQ0FDOUJ2QyxPQUFPd0MsVUFEdUIsRUFFOUJ4QyxPQUFPeUMsVUFGdUIsRUFHOUJ6QyxPQUFPMEMsSUFIdUIsQ0FBaEM7QUFLQSxZQUFJQyxjQUFZTCw0QkFBMEJNLHVCQUExQixFQUFoQjs7QUFFQWxFLHdCQUFjLHFCQUFZd0MsR0FBWixDQUNaeEMsYUFEWSxFQUVaLEVBQUN5RSxnQkFBZ0JiLDJCQUFqQixFQUZZLENBQWQ7QUFJQTVELHdCQUFjLDBCQUFpQjBFLGlCQUFqQixDQUNaMUUsYUFEWSxFQUVaaUUsV0FGWSxFQUdaM0MsT0FBT2lELElBSEssQ0FBZDtBQUtBLDRCQUNLbEQsS0FETDtBQUVFckIsb0NBRkY7QUFHRTZDLHFCQUFXOUMsYUFBYTtBQUN0QkMsc0NBRHNCO0FBRXRCQyxvQ0FGc0I7QUFHdEJDLG9DQUhzQjtBQUl0QkM7QUFKc0IsV0FBYjtBQUhiO0FBVUQ7O0FBRUQ7QUFBbUI7QUFBQSxZQUNYSCxjQURXLEdBQ0txQixLQURMLENBQ1hyQixXQURXOztBQUVqQixZQUFJaUQsaUJBQWVqRCxlQUFZTyxpQkFBWixFQUFuQjtBQUNBLFlBQUlvRSxRQUFRMUIsZUFBYXpDLGNBQWIsQ0FBNEJjLE9BQU9zRCxRQUFuQyxDQUFaO0FBQ0EsWUFBSUMsY0FBYyw0QkFBbUI7QUFDbkNDLHFCQUFXeEQsT0FBT3NELFFBRGlCO0FBRW5DRyx3QkFBYyxDQUZxQjtBQUduQ0Msb0JBQVUxRCxPQUFPc0QsUUFIa0I7QUFJbkNLLHVCQUFhTixNQUFNTyxTQUFOO0FBSnNCLFNBQW5CLENBQWxCO0FBTUEsWUFBSUMsZUFBZSxrQkFBU0MsV0FBVCxDQUNqQm5DLGNBRGlCLEVBRWpCNEIsV0FGaUIsRUFHakIsVUFIaUIsQ0FBbkI7QUFLQSxZQUFJUSxhQUFhLGtCQUFTL0IsWUFBVCxDQUNmNkIsWUFEZSxFQUVmQSxhQUFhMUIsaUJBQWIsRUFGZSxFQUdmLFVBSGUsQ0FBakI7O0FBTUFSLHlCQUFlLHFCQUFZTSxJQUFaLENBQWlCdkQsY0FBakIsRUFBOEJxRixVQUE5QixFQUEwQyxjQUExQyxDQUFmO0FBQ0FyRix5QkFBYyxxQkFBWXdELGNBQVosQ0FDWlAsY0FEWSxFQUNFb0MsV0FBVzVCLGlCQUFYLEVBREYsQ0FBZDtBQUdBLDRCQUNLcEMsS0FETDtBQUVFckI7QUFGRjtBQUlEOztBQUVEO0FBQXlCO0FBQUEsWUFDakJBLGNBRGlCLEdBQ1dxQixLQURYLENBQ2pCckIsV0FEaUI7QUFBQSxZQUNKdUMsWUFESSxHQUNXbEIsS0FEWCxDQUNKa0IsVUFESTs7QUFFdkIsWUFBSVUsaUJBQWVqRCxlQUFZTyxpQkFBWixFQUFuQjtBQUNBMEMseUJBQWVBLGVBQWFxQyxlQUFiLENBQ2JoRSxPQUFPMkMsU0FETSxFQUViM0MsT0FBTzBDLElBRk0sQ0FBZjtBQUlBaEUseUJBQWMscUJBQVlrRCxpQkFBWixDQUNaRCxjQURZLEVBRVosZ0NBQXVCVixZQUF2QixDQUZZLENBQWQ7O0FBS0EsNEJBQ0tsQixLQURMO0FBRUVyQjtBQUZGO0FBSUQ7QUF6YUg7QUEyYUQsQ0E1YUQ7O0FBOGFBLElBQUl1RixlQUFlLEVBQW5COztrQkFFZSxZQUFrQztBQUFBLE1BQWpDbEUsS0FBaUMsdUVBQXpCa0UsWUFBeUI7QUFBQSxNQUFYakUsTUFBVztBQUFBLE1BQ3pDc0IsVUFEeUMsR0FDMUJ0QixNQUQwQixDQUN6Q3NCLFVBRHlDOzs7QUFHL0MsTUFBSUEsVUFBSixFQUFnQjtBQUNkLHdCQUNLdkIsS0FETCxzQkFFR3VCLFVBRkgsRUFFZ0J4QixjQUFjQyxNQUFNdUIsVUFBTixDQUFkLEVBQWlDdEIsTUFBakMsQ0FGaEI7QUFJRCxHQUxELE1BS087QUFDTCxXQUFPRCxLQUFQO0FBQ0Q7QUFDRixDIiwiZmlsZSI6InJlZHVjZXJzL2luZGV4LmpzIiwic291cmNlUm9vdCI6IkU6XFxwcm9qZWN0c1xccmVkdXgtZHJhZnRcXHNyYyJ9



//////////////////
// WEBPACK FOOTER
// ../lib/reducers/index.js
// module id = 589
// module chunks = 0